import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Box, Typography } from '@mui/material';

const DataPolicyDialog = ({ open, handleClose }) => {
    return (
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
            <DialogTitle>Data Policy</DialogTitle>
            <DialogContent dividers>
                <DialogContentText component="div">
                    <Box>
                        <Typography variant="h6">1. Data We Collect</Typography>
                        <Typography variant="body2" mt={1} paragraph>
                            We collect only the personal data necessary to provide and improve our services. This includes:
                        </Typography>
                        <ul>
                            <li>Email address, used for account creation and communication.</li>
                            <li>Session summaries, enabling you to track your progress.</li>
                            <li>Statistics such as the number of sessions and tasks completed, to enhance your experience.</li>
                        </ul>

                        <Typography variant="h6" mt={3}>2. How We Use Your Data</Typography>
                        <Typography variant="body2" mt={1} paragraph>
                            The data we collect is used to:
                        </Typography>
                        <ul>
                            <li>Provide personalised services and features tailored to your needs.</li>
                            <li>Track your progress and maintain continuity in your sessions.</li>
                            <li>Generate anonymized insights to improve the overall functionality and user experience.</li>
                            <li>Encrypted conversations are stored securely in our secure database. No decrypted conversations are stored on our servers.</li>
                        </ul>

                        <Typography variant="h6" mt={3}>3. Sharing and Third-Party Services</Typography>
                        <Typography variant="body2" mt={1} paragraph>
                            Your data is handled with the utmost care and is never sold to third parties. We work with trusted partners for essential services such as hosting, analytics, and operational support, ensuring they adhere to strict confidentiality and security standards.
                        </Typography>

                        <Typography variant="h6" mt={3}>4. Data Security</Typography>
                        <Typography variant="body2" mt={1} paragraph>
                            We implement rigorous security measures to safeguard your data, including encryption, secure storage, and regular system audits. Access to your personal data is restricted to authorized personnel only.
                        </Typography>
                        <Typography variant="body2" mt={1} paragraph>
                            Session data is retained for up to 30 days to enhance your experience, after which it is securely deleted. Your data is not used to train external models or for purposes beyond those explicitly stated.
                        </Typography>

                        <Typography variant="h6" mt={3}>5. Managing Your Data</Typography>
                        <Typography variant="body2" mt={1} paragraph>
                            You can access, update, or delete your personal data at any time by contacting us. We also provide tools within the platform to manage your preferences and ensure transparency in how your data is used.
                        </Typography>

                        <Typography variant="h6" mt={3}>6. Contact Information</Typography>
                        <Typography variant="body2" mt={1} paragraph>
                            If you have any questions, concerns, or require assistance with your data, please contact us at <a href="mailto:hello@zosa.app" style={{ color: '#5D87FF' }}>hello@zosa.app</a>. Our team is committed to addressing your concerns promptly and effectively.
                        </Typography>
                    </Box>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary" variant="contained">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DataPolicyDialog;
